<template>
  <div class="content">
    <NavbarShowcase />
    <v-main>
      <v-container fluid>
        <v-card>
          <v-card-title>Proceso de Inscripción</v-card-title>
          <v-card-subtitle>{{ course_name }}</v-card-subtitle>
          <v-card-text>
            <div class="mb-5">
              <v-progress-linear :model-value="progress" color="amber" :height="5"></v-progress-linear>
            </div>
            <div class="mb-5">
              <v-alert title="Política de Tratamiento de Datos Personales">
                <div>Para La Fundación United Way Colombia es muy importante conocer cómo impactamos en los territorios. Al confirmar tu inscripción, estarás aceptando que los datos 
                  registrados sean tratados de acuerdo a nuestra <a target="_blank" href="https://unitedwaycolombia.org/wp-content/uploads/2024/12/Politica_tratamientio_de_datos_2025.pdf">Política de Tratamiento de Datos Personales</a>.</div>
              </v-alert>                    
            </div>
            <v-window v-model="step">
              <v-window-item :key="1" :value="1">
                <div class="d-flex flex-column">
                  <div class="text-uppercase font-weight-bold">Validar Número de Documento</div>
                  <div>Ingrese su número de documento para validar si ya se encuentra registrado en el sistema.</div>
                  <div class="data-input-content my-3">
                    <v-select class="data-input" v-model="participant.documento_tipo" variant="outlined" density="compact" label="Tipo de documento" 
                    :items="documenttype" item-title="label" item-value="value"
                    :error-messages="v1$.documento_tipo.$errors.map(e => e.$message)">
                    </v-select>

                    <v-text-field class="data-input" v-model="participant.documento" variant="outlined" density="compact" 
                    placeholder="Número de documento (Este campo solo acepta números)" label="Número de documento"
                    onkeypress="return event.charCode>=48 && event.charCode<=57"
                    :error-messages="v1$.documento.$errors.map(e => e.$message)"/>

                    <v-select class="data-input" v-model="participant.jornada" variant="outlined" density="compact" label="Disponibilidad de tiempo" 
                    :items="[ { title: 'Mañana', value: 'AM' }, { title: 'Tarde', value: 'PM' }, { title: 'Mañana y Tarde', value: 'AP' } ]" item-value="value" item-title="title"
                    :error-messages="v1$.jornada.$errors.map(e => e.$message)"/>
                  </div>
                  <div class="mb-auto"></div>
                  <div class="d-flex">
                    <v-btn variant="text" @click="$router.push({name: 'showcasepublic'})">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" variant="flat" :loading="loading" @click="validate()" >
                      Validar
                    </v-btn>
                  </div>
                </div>                
              </v-window-item>
              <v-window-item :key="2" :value="2">
                <div class="d-flex flex-column">
                  <div class="text-uppercase font-weight-bold">Datos Personales</div>
                  <div>Complete los siguientes datos personales.</div>
                  <div class="data-input-content my-3">
                    <v-text-field class="data-input" v-model="participant.nombres" variant="outlined" density="compact" label="Nombres"
                    :error-messages="v2$.nombres.$errors.map(e => e.$message)"/>
                    <v-text-field class="data-input" v-model="participant.apellidos" variant="outlined" density="compact" label="Apellidos" 
                    :error-messages="v2$.apellidos.$errors.map(e => e.$message)"/>
                    <v-text-field class="data-input" v-model="participant.correo_principal" variant="outlined" density="compact" label="Correo electrónico principal" 
                    :error-messages="v2$.correo_principal.$errors.map(e => e.$message)"/>
                    <v-text-field class="data-input" v-model="participant.correo_secundario" variant="outlined" density="compact" label="Correo electrónico secundario" 
                    :error-messages="v2$.correo_secundario.$errors.map(e => e.$message)"/>
                    <v-text-field class="data-input" v-model="participant.contacto_principal" variant="outlined" density="compact" label="Número de contacto principal" 
                    :error-messages="v2$.contacto_principal.$errors.map(e => e.$message)"/>
                    <v-text-field class="data-input" v-model="participant.contacto_secundario" variant="outlined" density="compact" label="Número de contacto secundario" 
                    :error-messages="v2$.contacto_secundario.$errors.map(e => e.$message)"/>
                    
                    <v-select class="data-input" v-model="participant.pais" variant="outlined" density="compact" label="País donde trabajas actualmente" 
                    :items="country" item-title="label" item-value="value" prepend-icon="mdi-help-circle-outline"
                    :error-messages="v2$.pais.$errors.map(e => e.$message)"
                    @update:modelValue="changeCountry()"
                    @click:prepend="help.pais = !help.pais">
                      <template v-slot:prepend>
                        <v-tooltip v-model="help.pais" activator="parent" location="bottom">
                          País donde trabaja o estudia
                        </v-tooltip>
                      </template>
                    </v-select>
                    
                    <v-select class="data-input" v-model="participant.departamento" variant="outlined" density="compact" label="Departamento donde trabajas actualmente" 
                    :items="department" item-value="value" item-title="label" prepend-icon="mdi-help-circle-outline"
                    :disabled="participant.pais !== 'Colombia'"
                    :error-messages="v2$.departamento.$errors.map(e => e.$message)"
                    @update:model-value="changeDepartment()"
                    @click:prepend="help.departamento = !help.departamento">
                      <template v-slot:prepend>
                        <v-tooltip v-model="help.departamento" activator="parent" location="bottom">
                          Departamento donde trabaja o estudia
                        </v-tooltip>
                      </template>
                    </v-select>
                    
                    <v-select class="data-input" v-model="participant.ciudad" variant="outlined" density="compact" label="Ciudad donde trabajas actualmente" 
                    :items="city" item-value="value" item-title="label" prepend-icon="mdi-help-circle-outline"
                    :disabled="participant.pais !== 'Colombia'" 
                    :error-messages="v2$.ciudad.$errors.map(e => e.$message)"
                    @update:model-value="changeCity()"
                    @click:prepend="help.ciudad = !help.ciudad">
                      <template v-slot:prepend>
                        <v-tooltip v-model="help.ciudad" activator="parent" location="bottom">
                          Ciudad o municipio donde trabaja o estudia
                        </v-tooltip>
                      </template>
                    </v-select>

                    <v-select class="data-input" v-model="participant.edad" variant="outlined" density="compact" label="Rango de edad" 
                    :items="ages" item-value="value" item-title="label"
                    @update:modelValue="changeRole()"
                    :error-messages="v2$.edad.$errors.map(e => e.$message)"/>
                    
                  </div>
                  <div class="mb-auto"></div>
                  <div class="d-flex">
                    <v-btn variant="text" @click="back()">Anterior</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" variant="flat" :loading="loading" @click="data()" >
                      Siguiente
                    </v-btn>
                  </div>
                </div>
              </v-window-item>
              <v-window-item :key="3" :value="3">
                <div class="d-flex flex-column">
                  <div class="text-uppercase font-weight-bold">Caracterización</div>
                  <div>Por favor completa los siguientes datos, para la Fundación es muy importante conocer nuestra población.</div>
                  <div class="data-input-content my-3">

                    <v-select class="data-input" v-model="participant.cargo" variant="outlined" density="compact" label="Rol o Eres" 
                    :items="roles" item-value="value" item-title="label" prepend-icon="mdi-help-circle-outline"
                    :error-messages="v3$.cargo.$errors.map(e => e.$message)"
                    @update:modelValue="changeRole()"
                    @click:prepend="help.cargo = !help.cargo">
                      <template v-slot:prepend>
                        <v-tooltip v-model="help.cargo" activator="parent" location="bottom">
                          Cargo o rol que desempeñas en tu lugar de trabajo o estudio
                        </v-tooltip>
                      </template>
                    </v-select>

                    <v-select class="data-input" v-model="participant.trayectoria" variant="outlined" density="compact" label="Trayectoria en el cargo" 
                    :items="trajectory" item-value="value" item-title="label" prepend-icon="mdi-help-circle-outline"
                    :disabled="participant.cargo === null"
                    :error-messages="v3$.trayectoria.$errors.map(e => e.$message)"
                    @click:prepend="help.trayectoria = !help.trayectoria">
                      <template v-slot:prepend>
                        <v-tooltip v-model="help.trayectoria" activator="parent" location="bottom">
                          Descripción de la trayectoria dentro del cargo o rol que desempeña.
                        </v-tooltip>
                      </template>
                    </v-select>

                    <v-select class="data-input" v-model="participant.tipo_institucion" variant="outlined" density="compact" label="Tipo de organización a la que perteneces" 
                    :items="institutiontype" item-value="value" item-title="label" 
                    :disabled="participant.cargo === null"
                    :error-messages="v3$.tipo_institucion.$errors.map(e => e.$message)"/>

                    <v-select class="data-input" v-model="participant.ubicacion_institucion" variant="outlined" density="compact" label="Zona de la entidad donde estás vinculado" 
                    :items="location" item-value="value" item-title="label"
                    :error-messages="v3$.ubicacion_institucion.$errors.map(e => e.$message)"/>

                    <v-autocomplete class="data-input" v-model="participant.id_institucion" variant="outlined" density="compact" label="Institución a la que perteneces" 
                    :items="institutionid" item-value="value" item-title="label" 
                    :error-messages="v3$.id_institucion.$errors.map(e => e.$message)"/>

                    <v-select class="data-input" v-model="participant.formacion" variant="outlined" density="compact" label="Último nivel de formación alcanzado" 
                    :disabled="participant.cargo === null"
                    :items="formation" item-value="value" item-title="label" prepend-icon="mdi-help-circle-outline"
                    :error-messages="v3$.formacion.$errors.map(e => e.$message)"
                    @click:prepend="help.formacion = !help.formacion">
                      <template v-slot:prepend>
                        <v-tooltip v-model="help.formacion" activator="parent" location="bottom">
                          Selecciona el mayor nivel educativo que ha alcanzado.
                        </v-tooltip>
                      </template>
                    </v-select>

                    <v-select class="data-input" v-model="participant.genero" variant="outlined" density="compact" label="Sexo de nacimiento" 
                    :items="gender" item-value="value" item-title="label"
                    :error-messages="v3$.genero.$errors.map(e => e.$message)"/>

                  </div>
                  <div class="mb-auto"></div>
                  <div class="d-flex">
                    <v-btn variant="text" @click="back()">Anterior</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" variant="flat" :loading="loading" @click="characterization()" >
                      Siguiente
                    </v-btn>
                  </div>
                </div>
              </v-window-item>
              <v-window-item :key="4" :value="4">
                <div class="d-flex flex-column">
                  <div class="text-uppercase font-weight-bold">Resumen de inscripción</div>
                  <div>Por favor confirma tu registro e inscripción</div>
                  <div class="my-3">
                    <div>
                      <v-list lines="one">
                        <v-list-item title="Número de identificación" :subtitle="participant.documento">
                          <template v-slot:prepend>
                            <v-icon color="green-darken-4" icon="mdi-check-all"></v-icon>
                          </template>
                        </v-list-item>
                        <v-list-item title="correo electrónico principal" :subtitle="participant.correo_principal">
                          <template v-slot:prepend>
                            <v-icon color="green-darken-4" icon="mdi-check-all"></v-icon>
                          </template>
                        </v-list-item>
                        <v-list-item title="Número de contacto principal" :subtitle="participant.contacto_principal">
                          <template v-slot:prepend>
                            <v-icon color="green-darken-4" icon="mdi-check-all"></v-icon>
                          </template>
                        </v-list-item>
                        <v-list-item title="Institución Educativa" :subtitle="participant.nombre_institucion" v-if="participant.nombre_institucion">
                          <template v-slot:prepend>
                            <v-icon color="green-darken-4" icon="mdi-check-all"></v-icon>
                          </template>
                        </v-list-item>
                      </v-list>
                    </div>
                  </div>
                  <div>
                    <v-checkbox v-model="accepted">
                      <template v-slot:label>
                        <div>
                          Autorizo expresamente a ser notificado hasta tres (3) veces por correo electrónico y/o teléfono celular por la Fundación United Way Colombia cuando dicha entidad encuentre errores e/o 
                          incoherencias en los datos suministrados por mí en los formularios con el fin de que yo los modifique y actualice. Autorizo expresamente a la Fundación United Way Colombia para que realice 
                          los ajustes correspondientes a los datos en caso de que yo no los modifique ni actualice después de haber sido notificado tres (3) veces sobre los errores e/o incoherencias en los datos suministrados. 
                          Lo anterior para que las mediciones, métricas y análisis de los datos que realice la Fundación United Way Colombia en virtud de su objeto social no se vean afectados.
                        </div>
                      </template>
                    </v-checkbox>
                    
                  </div>
                  <div class="mb-auto"></div>
                  <div class="d-flex">
                    <v-btn variant="text" @click="back()">Anterior</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" variant="flat" :loading="loading" :disabled="!accepted" @click="finish()" >
                      Confirmar mi inscripción
                    </v-btn>
                  </div>
                </div>
              </v-window-item>
            </v-window>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
    <!-- success -->
    <v-dialog v-model="success.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="success" icon="mdi-check-circle" size="112" />
        <h2 class="text-h5 mb-6">Resultado Inscripción</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ success.text }}
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="success" variant="flat" text="Volver a la vitrina" @click="$router.push({name: 'showcasepublic'})"/>
        </div>        
      </v-sheet>
    </v-dialog>

    <!-- error -->
    <v-dialog v-model="error.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-close-circle" size="112" />
        <h2 class="text-h5 mb-6">Error</h2>
        <p class="mb-4 text-medium-emphasis text-body-2" v-html="error.text"></p>
        <v-divider class="mb-4"></v-divider>
        <div class="text-end">
          <v-btn class="text-none" color="error" variant="flat" text="Aceptar" @click="error.state = false"/>
      </div>
      </v-sheet>
    </v-dialog>

    <!-- failed -->
    <v-dialog v-model="failed.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-calendar-remove" size="112" />
        <h2 class="text-h5 mb-3">Parece que ha ocurrido un error</h2>
        <p class="m-4 text-medium-emphasis text-body-2">
          {{  failed.text  }}
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="error" variant="plain" prepend-icon="mdi-open-in-new" text="www.unitedwaycolombia.org" @click="openlink('https://unitedwaycolombia.org')"/>
        </div>
      </v-sheet>
    </v-dialog>

    <!-- Process -->
    <v-dialog v-model="process" max-width="320" persistent >
      <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
        <v-list-item prepend-icon="mdi-clock" title="Espera..." >
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>
  </div>
</template>
<script setup>
  import axios from 'axios';
  import NavbarShowcase from '../components/navbar/NavbarShowcase';
  import Params from '@/models/params';
  import Participant from '@/models/participant';
  import { ref, reactive, computed, onMounted } from "vue";
  import { useRoute } from 'vue-router';
  import { useVuelidate } from '@vuelidate/core';
  import { required, numeric, minLength, maxLength, minValue, maxValue, email, helpers } from '@vuelidate/validators';

  const success = reactive({
    state: false,
    text: null
  })

  const error = reactive({
    state: null,
    text: null
  })

  const failed = reactive({
    state: null,
    text: null
  })

  const help = reactive({
    pais: false,
    departamento: false,
    ciudad: false,
    cargo: false,
    trayectoria: false,
    formacion: false,
    edad: false,
    sexo: false
  })

  const participant = reactive(new Participant)

  const customEmail = (value) => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9._%+-]+\.(com|es|org|co|edu|edu\.co)$/;
    return regex.test(value);
  };

  const params = ref(new Params)
  const step = ref(1)
  const previously = ref(1)
  const progress = ref(20)
  const process = ref(true)
  const loading = ref(false)
  const accepted = ref(false)

  const route = useRoute();
  const convocatory = route.params.code;
  const course = route.params.route;
  const course_name = ref(null);

  const location = ref(params.value.location)
  const gender = ref(params.value.gender)
  const country = ref(params.value.country)
  const documenttype = ref(params.value.document_type)
  const department = ref([])
  const city = ref([])
  const institutionid = ref([])
  const formation = ref([])
  const ages = ref([])
  const roles = ref([])
  const trajectory = ref([])
  const institutiontype = ref([])

  const rulesStepOne = computed(() => {
    return {
      documento: { 
        required: helpers.withMessage('Campo requerido.', required), 
        numeric: helpers.withMessage('Solo números.', numeric), 
        minLength: helpers.withMessage('Mínimo 6 números.', minLength(5)), 
        maxLength: helpers.withMessage('Máximo 15 números.', maxLength(15)), 
      },
      documento_tipo: { required: helpers.withMessage('Campo requerido.', required) },
      jornada: { required: helpers.withMessage('Campo requerido.', required) }
    }
  })

  const rulesSteoTwo = computed(() => {
    return {
      nombres: { required: helpers.withMessage('Campo requerido.', required) },
      apellidos: { required: helpers.withMessage('Campo requerido.', required) },
      correo_principal: { 
        required: helpers.withMessage('Campo requerido.', required),
        email: helpers.withMessage('Formato inválido.', email),
        customEmail: helpers.withMessage('El correo debe terminar con .com, .es, .org, .co, .edu, .edu.co ', customEmail)
      },
      correo_secundario: { 
        email: helpers.withMessage('Formato inválido.', email)
      },
      contacto_principal: {
        required: helpers.withMessage('Campo requerido.', required),
        numeric: helpers.withMessage('Solo números.', numeric),
        minLength: helpers.withMessage('Mínimo 7 números.', minLength(7)), 
        maxLength: helpers.withMessage('Máximo 10 números.', maxLength(10)), 
      },
      contacto_secundario: {
        numeric: helpers.withMessage('Solo números.', numeric),
        minLength: helpers.withMessage('Mínimo 7 números.', minLength(7)), 
        maxLength: helpers.withMessage('Máximo 10 números.', maxLength(10)), 
      },
      pais: { required: helpers.withMessage('Campo requerido.', required) },
      departamento: { required: helpers.withMessage('Campo requerido.', required) },
      ciudad: { required: helpers.withMessage('Campo requerido.', required) },
      edad: { required: helpers.withMessage('Campo requerido.', required) },
    }
  })

  const rulesStepThree = computed(() => {
    return{
      cargo: { required: helpers.withMessage('Campo requerido.', required) },
      trayectoria: { required: helpers.withMessage('Campo requerido.', required) },
      formacion: { required: helpers.withMessage('Campo requerido.', required) },
      genero: { required: helpers.withMessage('Campo requerido.', required) },
      migrantes: { 
        required: helpers.withMessage('Campo requerido.', required),
        numeric: helpers.withMessage('Solo números.', numeric),
        minValue: helpers.withMessage('Solo valores entre 0 y 100.', minValue(0)), 
        maxValue: helpers.withMessage('Solo valores entre 0 y 100.', maxValue(100)), 
      },
      tipo_institucion: { required: helpers.withMessage('Campo requerido.', required) },
      id_institucion: { required: helpers.withMessage('Campo requerido.', required) },
      ubicacion_institucion: { required: helpers.withMessage('Campo requerido.', required) },
    }
  })

  const v1$ = useVuelidate(rulesStepOne, participant)
  const v2$ = useVuelidate(rulesSteoTwo, participant)
  const v3$ = useVuelidate(rulesStepThree, participant)

  async function load(){
    const frmquota = new FormData;
    frmquota.append('action','validarcupo');
    frmquota.append("route", course);
    const quota = await eject(frmquota);
    if(quota.datos[0].proyeccion <= quota.datos[0].solicitudes){
      failed.text = 'Ya se ha llenado el cupo, por favor intenta en otro evento o ruta de formación.';
      failed.state = true;
      process.value = false;
      return;
    }

    department.value = await params.value.department()
    ages.value = await params.value.age()

    const frm = new FormData;
    frm.append("action","rutas");
    frm.append("value",course);
    const result = await eject(frm);
    process.value = false;
    if(result.state){
      course_name.value = result.data[0].oferta;
    }
  }

  async function validate(){
    if(!await v1$.value.$validate()){
      return
    }
    loading.value = true;
    const f = new FormData;
    f.append("action", "validar");
    f.append("value", participant.documento);
    const result = await eject(f);
    step.value = previously.value = result.step;
    
    progress.value = result.step * 20;
    if(step.value == 4){
      participant.inscripcion = result.data.idinscripcion;
      participant.correo_principal = result.data.correo_principal;
      participant.contacto_principal = result.data.contacto_principal;
      participant.nombres = result.data.nombres;
      participant.id_institucion = result.data.idinstitucion;
      participant.nombre_institucion = result.data.institucion;
    }
    
    loading.value = false;
  }

  async function data(){
    if(!await v2$.value.$validate()){
      return
    }
    loading.value = true;
    participant.cargo = null
    roles.value = await params.value.roles(participant.edad)
    progress.value = 70;
    step.value = 3;
    loading.value = false;
  }

  async function characterization(){
    if(!await v3$.value.$validate()){
      return
    }
    loading.value = true;
    progress.value = 100;
    step.value = 4;
    loading.value = false;
  }

  async function finish(){
    let data = null;
    try {
      loading.value = true;
      const frm = new FormData;
      frm.append("action", "matricular");
      frm.append("data", JSON.stringify(participant));
      frm.append("convocatory", convocatory);
      frm.append("route", course);
      const result = await eject(frm);
      data = result;
      loading.value = false;
      if(result.state){
        success.text = result.message;
        success.state = true;
      }else{
        error.text = result.message;
        error.state = true;
      }
    } catch (error) {
      failed.text = data.message ? data.message : 'No se ha podido completar el proceso, por favor contacta a soporte o comunícate con tu enlace de United Way Colombia.';
      failed.state = true;
    }
  }

  //Auxiliar
  async function changeRole(){
    participant.trayectoria = null
    participant.formacion = null
    participant.tipo_institucion = null
    trajectory.value = await params.value.trajectory(participant.cargo, participant.edad)
    formation.value = await params.value.formation(participant.edad)
    institutiontype.value = await params.value.institutiontype(participant.cargo, participant.edad)
  }

  async function changeCountry(){
    if(participant.pais !== 'Colombia'){
      participant.departamento = 100;
      participant.ciudad = 99998;
      participant.tipo_institucion = 8;
      participant.id_institucion = 1;
      city.value = await params.value.city(participant.departamento);
      institutionid.value = await params.value.institutions(participant.ciudad)
    }else{
      participant.departamento = null;
      participant.ciudad = null;
      participant.tipo_institucion = null;
      participant.id_institucion = null;
    }
  }

  async function changeDepartment(){
    participant.ciudad = null;
    participant.id_institucion = null;
    institutionid.value = [];
    city.value = await params.value.city(participant.departamento);
  }

  async function changeCity(){
    institutionid.value = await params.value.institutions(participant.ciudad);
  }

  function back(){

    let aux = step.value - 1;
    if(aux < previously.value){
      step.value = 1;
    }else{
      step.value = aux;
    }
    progress.value = step.value * 20;
    
  }

  function eject(f){
    return new Promise((resolve) => {
      axios.post(params.value.controller + 'vitrina.php',f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
    })
  }

  onMounted(() => {
    load();
  })
</script>